// Inima de favorite (♡ + nr. urmaritori), ca la Troostwijk (23 oct 2026).
// Folosita pe pagina produsului si pe carduri: orice <button class="fav-heart"
// data-product-id="..."> din pagina. Clientul logat -> App Proxy (verificat de
// Shopify); vizitatorul vede doar numarul si e trimis la login la click.
(function () {
  const API = 'https://2hand-sync.vercel.app/api';
  const customerId = (document.querySelector('[data-fav-customer]') || {}).dataset?.favCustomer || '';

  function render(btn, favorited, count) {
    btn.dataset.favorited = favorited ? '1' : '0';
    btn.classList.toggle('is-fav', !!favorited);
    btn.setAttribute('aria-pressed', favorited ? 'true' : 'false');
    btn.setAttribute('aria-label', favorited ? 'Scoate de la favorite' : 'Adaugă la favorite');
    const c = btn.querySelector('.fav-heart-count');
    if (c) c.textContent = count > 0 ? String(count) : '';
  }

  // O singura cerere pt toate inimile din pagina: clientul logat -> App Proxy
  // (contoare + care sunt ale lui); vizitatorul -> doar contoarele publice.
  async function loadAll(buttons) {
    if (!buttons.length) return;
    const ids = [...new Set(buttons.map(b => b.dataset.productId))].join(',');
    let counts = {}, mine = new Set();
    try {
      if (customerId) {
        const r = await fetch(`/apps/sistem-propriu/favorite-status?product_ids=${ids}`);
        if (r.ok) { const d = await r.json(); counts = d.counts || {}; mine = new Set((d.favorited_ids || []).map(String)); }
        else counts = (await (await fetch(`${API}/auction-status?fav_ids=${ids}`)).json()).counts || {};
      } else {
        counts = (await (await fetch(`${API}/auction-status?fav_ids=${ids}`)).json()).counts || {};
      }
    } catch (e) { /* fara contor, inima ramane functionala */ }
    for (const b of buttons) render(b, mine.has(b.dataset.productId), counts[b.dataset.productId] || 0);
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button.fav-heart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (!customerId) {
      // 2 nov 2026: intai panoul cu explicatia logarii (cod pe email), apoi Shopify
      const ret = location.pathname + location.search;
      const opener = document.querySelector('a[data-panel="login"]');
      const inp = document.querySelector('#login.h2-login [data-h2-return]');
      if (opener && inp) { inp.value = ret; opener.click(); }
      else location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(ret);
      return;
    }
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1';
    const on = btn.dataset.favorited !== '1';
    const c = btn.querySelector('.fav-heart-count');
    const prev = Number(c && c.textContent) || 0;
    render(btn, on, Math.max(0, prev + (on ? 1 : -1))); // raspuns instant
    try {
      const r = await (await fetch('/apps/sistem-propriu/set-favorite', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: Number(btn.dataset.productId), on }),
      })).json();
      if (r.ok) render(btn, r.favorited, r.count);
      else render(btn, !on, prev);
    } catch (err) {
      render(btn, !on, prev);
    } finally {
      delete btn.dataset.busy;
    }
  }, true);

  window.loadFavoriteHearts = (root) => loadAll([...(root || document).querySelectorAll('button.fav-heart:not([data-fav-loaded])')].map(b => { b.dataset.favLoaded = '1'; return b; }));
  function start() {
    window.loadFavoriteHearts();
    // Cardurile adaugate ulterior (filtre / paginare AJAX ale temei) primesc si ele starea.
    let t = null;
    new MutationObserver(() => {
      if (t) return;
      t = setTimeout(() => { t = null; if (document.querySelector('button.fav-heart:not([data-fav-loaded])')) window.loadFavoriteHearts(); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
